﻿import { GMetrixDialog } from 'components/GMetrixDialog/GMetrixDialog';
import { Api } from 'pages/orders/fulfillment_manager/Api';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { Fulfillment } from 'types';
import { useApp } from 'app';

import 'pages/orders/fulfillment_manager/components/AddFulfillment/styles/AddFulfillment.scss';

interface AddFulfillmentProps {
	modalOpen: boolean;
	onAddCompletion: (newFulfillment: Fulfillment) => void;
	onCancelClick: () => void;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddFulfillment = (props: AddFulfillmentProps) => {

    const { modalOpen, onAddCompletion, onCancelClick, setModalOpen } = props;

    const [state, setState] = useSuperState({
        code: '',
        deliverableType: 1 as number,
        description: ''
    });

    const { code, deliverableType, description } = state;

    const { userId } = useApp();
    const { formatMessage } = useIntl();

    const deliverableTypes = [
        { name: 'Practice Test', value: 1 },
        { name: 'EBook', value: 2 },
        { name: 'Course', value: 3 }
    ];

    const onAddClick = async () => {

        try {

            const res = await Api.AddFulfillment(code, deliverableType, description, userId);
            if (res.Successful && res.DataExtra !== undefined){

                onAddCompletion({
                    Code: code,
                    Count: 0,
                    DeliverableTypeId: deliverableType,
                    DeliverableTypeName: deliverableTypes.filter(item => item.value === deliverableType)[0].name,
                    Description: description,
                    ExternalId: res.DataExtra
                });

            }

        } catch {

            // Failed to add fulfillment

        }
        setModalOpen(false);

    };

    return (
        <GMetrixDialog
            showActionButton
            onCancel={() => {

                setModalOpen(false);
                onCancelClick();

            }}
            actionButtonClick={onAddClick}
            actionButtonDisabled={code.replace(' ', '') === ''}
            actionButtonText={formatMessage({ id: 'add.e3ee51bb', defaultMessage: 'Add' })}
            dialogLabel={formatMessage({ id: 'add_fulfillment_code.35d9e154', defaultMessage: 'Add Fulfillment Code' })}
            show={modalOpen}
            showModalLabel={true}
            size="lg"
        >
            <div>
                <Form.Group className="mb-3">
                    <Form.Label className="text-title text-medium">
                        <FormattedMessage defaultMessage="Code" id="code.cc651d9c" />
                    </Form.Label>
                    <Form.Control
                        onChange={e => setState({ code: e.target.value })}
                        type="text"
                        value={code}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label className="text-title text-medium">
                        <FormattedMessage defaultMessage="Type" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="type.a129b9e6" />
                    </Form.Label>
                    <Form.Select
                        onChange={e => setState({ deliverableType: parseInt(e.target.value) })}
                        value={deliverableType}
                    >
                        <option value={1}>
                            {formatMessage({ id: 'test.85b4d085', defaultMessage: 'Test', description: 'Gridview header' })}
                        </option>
                        <option value={2}>
                            {formatMessage({ id: 'ebook.5d34c24a', defaultMessage: 'EBook' })}
                        </option>
                        <option value={3}>
                            {formatMessage({ id: 'course.790646f3', defaultMessage: 'Course' })}
                        </option>
                    </Form.Select>
                </Form.Group>
                <Form.Group>
                    <Form.Label className="text-title text-medium">
                        <FormattedMessage defaultMessage="Description" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="description.6317db73" />
                    </Form.Label>
                    <Form.Control
                        onChange={e => setState({ description: e.target.value })}
                        value={description}
                    />
                </Form.Group>
            </div>
        </GMetrixDialog>
    );

};
